(function () {
  'use strict';

  function initBlogFilters() {
    var hub = document.querySelector('[data-eride-dealer-blog]');
    if (!hub) return;

    var filters = hub.querySelectorAll('[data-eride-filter]');
    var cards = hub.querySelectorAll('[data-eride-article-card]');
    var noResults = hub.querySelector('[data-eride-no-results]');
    if (!filters.length || !cards.length) return;

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-eride-filter');

        filters.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-eride-filter') === tag);
        });

        var visible = 0;
        cards.forEach(function (card) {
          var cardTags = (card.getAttribute('data-tags') || '').toLowerCase();
          var show = tag === 'all' || cardTags.indexOf(tag.toLowerCase()) !== -1;
          card.classList.toggle('is-hidden', !show);
          if (show) visible += 1;
        });

        if (noResults) {
          noResults.classList.toggle('is-visible', visible === 0);
        }
      });
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.eride-reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBlogFilters();
    initReveal();
  });
})();
